module.exports = __webpack_public_path__ + "img/稿定设计-5.5e4e8e9c.jpg";